import { Content } from '@tiptap/react';

export const createSmartEditorFile = (fileName: string, content: Content) => {
  const jsonBlob = new Blob([JSON.stringify(content)]);
  return new File([jsonBlob], fileName, { type: 'application/json' });
};
